module.exports = {
	searchEngines: [
		{text: "Google", value: "google"},
		{text: "Google local", value: "googlelocal"},
		{text: "Yahoo", value: "yahoo"},
		{text: "Bing", value: "bing"},
		{text: "Yandex", value: "yandex"},
		{text: "Youtube", value: "youtube"},
		{text: "Naver", value: "naver"},
		{text: "Baidu", value: "baidu"},
		{text: "Google news", value: "googlenews"},
		{text: "Seznam", value: "seznam"},
		{text: "Sogou", value: "sogou"},
		{text: "Daumsite", value: "daumsite"}
	]
};